var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.68 6.5L24.425 9.5H30.5V27.5H6.5V9.5H12.575L15.32 6.5H21.68ZM23 3.5H14L11.255 6.5H6.5C4.85 6.5 3.5 7.85 3.5 9.5V27.5C3.5 29.15 4.85 30.5 6.5 30.5H30.5C32.15 30.5 33.5 29.15 33.5 27.5V9.5C33.5 7.85 32.15 6.5 30.5 6.5H25.745L23 3.5ZM18.5 14C20.975 14 23 16.025 23 18.5C23 20.975 20.975 23 18.5 23C16.025 23 14 20.975 14 18.5C14 16.025 16.025 14 18.5 14ZM18.5 11C14.36 11 11 14.36 11 18.5C11 22.64 14.36 26 18.5 26C22.64 26 26 22.64 26 18.5C26 14.36 22.64 11 18.5 11Z",
    fill: "#2E7FEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconBlue);
export default __webpack_public_path__ + "static/media/camera-icon-blue.fe3d6b59.svg";
export { ForwardRef as ReactComponent };